export const ControlLevel = {
  /**
   * Full control level means that the controller has all possible permissions set.
   */
  Full: 'Full',
  /**
   * Partial control level means that the controller has some permissions set.
   */
  Partial: 'Partial',
  /**
   * None control level means that the controller has no permissions set.
   */
  None: 'None',
} as const

export type ControlLevel = keyof typeof ControlLevel
